import { trigger_interaction } from "./Analytics";

export function selectComparisonAllLocations() {
  trigger_interaction("TABLE", "o", "COMPARISON, ALL L-1Q");
}

export function selectComparisonByView({ showYear }) {
  trigger_interaction("TABLE", "o", `COMPARISON, ${showYear ? "1L-ALLQ" : "1L-1Q"}`);
}

export function selectGraphAllValue({ selected }) {
  trigger_interaction("GRAPH", "o", `ALL L-1Q, VALUE, ${selected}`);
}

export function selectGraphCompare({ selected }) {
  trigger_interaction("GRAPH", "o", `1L-ALLQ, COMPARE, ${selected}`);
}

export function selectTableSampleSize() {
  trigger_interaction("TABLE", "o", "SAMPLE-SIZE");
}

export function selectMapSampleSize() {
  trigger_interaction("MAP", "o", "SAMPLE-SIZE");
}

export function selectYear() {
  trigger_interaction("QVIEW", "o", "YEAR");
}
